"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonEndIcon = exports.ButtonStartIcon = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var tokens_1 = require("@prezzee/tokens");
var style = __importStar(require("./Button.style"));
var theme_1 = require("@prezzee/theme");
var button_base_1 = __importDefault(require("@prezzee/button-base"));
var ButtonStartIcon = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ css: style.startIcon }, { children: children })));
};
exports.ButtonStartIcon = ButtonStartIcon;
var ButtonEndIcon = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ css: style.endIcon }, { children: children })));
};
exports.ButtonEndIcon = ButtonEndIcon;
var blackBtn = {
    base: tokens_1.colors.black,
    baseText: tokens_1.colors.white,
    hover: tokens_1.colors.gray500,
    hoverText: tokens_1.colors.white,
    active: tokens_1.colors.gray400,
    activeText: tokens_1.colors.white,
};
var whiteBtn = {
    base: tokens_1.colors.white,
    baseText: tokens_1.colors.black,
    hover: tokens_1.colors.gray100,
    hoverText: tokens_1.colors.black,
    active: tokens_1.colors.gray200,
    activeText: tokens_1.colors.black,
};
var variants = {
    outlined: function (color) { return style.outlined(color); },
    text: function (color) { return style.text(color); },
    contained: function (color) { return style.contained(color); },
};
var Button = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, _a = props.color, color = _a === void 0 ? 'primary' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, endIconProp = props.endIcon, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.size, size = _d === void 0 ? 'medium' : _d, _e = props.type, type = _e === void 0 ? 'button' : _e, startIconProp = props.startIcon, _f = props.variant, variant = _f === void 0 ? 'contained' : _f, rest = __rest(props, ["children", "color", "disabled", "endIcon", "fullWidth", "size", "type", "startIcon", "variant"]);
    var theme = (0, theme_1.useTheme)();
    var colors = __assign(__assign({}, theme.palette), { white: whiteBtn, black: blackBtn });
    var propStyles = [
        fullWidth && style.fullWidth,
        size && style.size(size),
        color && variant && variants[variant](colors[color]),
    ];
    var startIcon = startIconProp && (0, jsx_runtime_1.jsx)(exports.ButtonStartIcon, { children: startIconProp });
    var endIcon = endIconProp && (0, jsx_runtime_1.jsx)(exports.ButtonEndIcon, { children: endIconProp });
    return ((0, jsx_runtime_1.jsxs)(button_base_1.default, __assign({ css: __spreadArray([style.base], __read(propStyles), false), ref: ref, disabled: disabled, type: type }, rest, { children: [startIcon, children, endIcon] })));
});
Button.displayName = 'PrezzeeButton';
exports.default = Button;
//# sourceMappingURL=Button.js.map